import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { SonicApplicationData } from "../../../../common/classes/SonicApplication";
import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import { OfferStatus } from "../../../../utils/OfferStatus";
import EditableApplications from "./EditableApplications";
import {
  useGetApplicationByProject,
  useUpdateMultipleApplications,
} from "../../../../utils/useApplication";

type Props = {
  isSelect: boolean;
};
const EditableApplicationsContainer: React.FC<Props> = ({ isSelect }) => {
  const { id } = useParams<{ id: string }>();
  const auth_token = useAppSelector(getAuthToken);

  const { applications } = useGetApplicationByProject({
    auth_token,
    project_id: id,
    is_jikei_request: !isSelect,
  });

  const { multipleUpdate } = useUpdateMultipleApplications();

  const [status, setStatus] = useState<OfferStatus>();
  const handleStatus = (value: File | string | undefined) => {
    switch (value) {
      case OfferStatus.Complete:
      case OfferStatus.WaitingForInspection:
      case OfferStatus.UndergoingInspection:
      case OfferStatus.Cancelled:
        setStatus(value);
        break;
      default:
        setStatus(undefined);
        break;
    }
  };

  const [updateApplications, setUpdateApplications] = useState<
    Array<SonicApplicationData>
  >([]);

  const checkHandler = (app: SonicApplicationData) => {
    const updateArray = updateApplications;
    updateArray.push(app);
    setUpdateApplications([...updateArray]);
  };

  const uncheckHandler = (app: SonicApplicationData) => {
    const updateArray = updateApplications;
    setUpdateApplications([
      ...updateArray.filter((update) => update.id !== app.id),
    ]);
  };

  // ステータス変更時のユーザーへのメール送信の有無
  const [sendMail, setSendMail] = useState<boolean>(true);

  const handleSendMail = (isChecked: boolean) => {
    setSendMail(isChecked);
  };

  const handleUpdate = (cb: () => void) => {
    if (!status || applications.length === 0) {
      return;
    }
    const application_ids: Array<string> = [];
    updateApplications.forEach((app) => {
      application_ids.push(app.id);
    });

    if (application_ids.length > 0 && auth_token && id) {
      multipleUpdate({
        auth_token: auth_token,
        project_id: id,
        application_ids: application_ids,
        status: status,
        send_mail: sendMail,
        is_jikei_request: !isSelect,
        cb: () => {
          setUpdateApplications([]);
          setStatus(undefined);
          setSendMail(true);
          cb();
        },
      });
    }
  };

  const mailCopyHandler = () => {
    const mails: Array<string> = [];
    updateApplications.forEach((application) => {
      mails.push(application.applicant_email);
    });
    navigator.clipboard.writeText(mails.join(";"));
  };

  const resetHandler = () => {
    setUpdateApplications([]);
  };

  return (
    <EditableApplications
      completedApplications={applications.filter(
        (value: SonicApplicationData) => value.status === OfferStatus.Complete
      )}
      waitingApplications={applications.filter(
        (value: SonicApplicationData) =>
          value.status === OfferStatus.WaitingForInspection
      )}
      underGoingApplications={applications.filter(
        (value: SonicApplicationData) =>
          value.status === OfferStatus.UndergoingInspection
      )}
      cancelledApplications={applications.filter(
        (value: SonicApplicationData) => value.status === OfferStatus.Cancelled
      )}
      handleStatus={handleStatus}
      checkHandler={checkHandler}
      uncheckHandler={uncheckHandler}
      handleUpdate={handleUpdate}
      mailCopyHandler={mailCopyHandler}
      resetHandler={resetHandler}
      updateApplications={updateApplications}
      status={status}
      sendMail={sendMail}
      handleSendMail={handleSendMail}
      isSelect={isSelect}
    />
  );
};

export default EditableApplicationsContainer;
